(function () {
  // ─── Pattern-based jellyfish — per-slot independent cycling ───────────────
  // Fixed X-slots defined as % of viewport. Each slot can hold up to
  // MAX_PER_SLOT jellyfish simultaneously (stacked vertically with clearance).
  // Slots manage their own timers independently — no global loop timer.
  //
  // Zero horizontal overlap guaranteed on ALL viewports (≥15px gap at 375px):
  //   A[2–7%] ·B[12–25%] ·C[30–35%] ·D[39–52%] ·E[56–61%]
  //   ·F[65–78%] ·G[82–87%] ·H[92–99%]
  // ──────────────────────────────────────────────────────────────────────────

  var containers = document.querySelectorAll('.jellyfish-container');

  containers.forEach(function (container) {
    if (!container) return;
    if (container.dataset.floatingBgInit === '1') return;

    var imageUrl     = String(container.dataset.image  || '');
    var imagePoolRaw = String(container.dataset.images || '');
    var imagePool    = imagePoolRaw.split('||').map(function (u) { return u.trim(); }).filter(Boolean);

    if (!imageUrl && !imagePool.length) return;

    container.dataset.floatingBgInit = '1';
    container.setAttribute('aria-hidden', 'true');

    function getImg() {
      if (!imagePool.length) return imageUrl;
      return imagePool[Math.floor(Math.random() * imagePool.length)] || imageUrl;
    }

    var speedMult = parseFloat(container.dataset.speed || '100') / 100;

    // ── Pattern: fixed X-slots ────────────────────────────────────────────────
    // xPct = left edge %, wPct = width %, isLarge = depth/speed hint
    var SLOTS = [
      { xPct: 0.02,  wPct: 0.05,  isLarge: false },  // A
      { xPct: 0.12,  wPct: 0.13,  isLarge: true  },  // B
      { xPct: 0.30,  wPct: 0.05,  isLarge: false },  // C
      { xPct: 0.39,  wPct: 0.13,  isLarge: true  },  // D
      { xPct: 0.56,  wPct: 0.05,  isLarge: false },  // E
      { xPct: 0.65,  wPct: 0.13,  isLarge: true  },  // F
      { xPct: 0.82,  wPct: 0.05,  isLarge: false },  // G
      { xPct: 0.92,  wPct: 0.07,  isLarge: true  },  // H
    ];

    var CFG = {
      basePx:       22 * speedMult,
      smallFactor:  0.75,
      largeFactor:  1.00,
      overscanPx:   220,
      // Max jellyfish per slot simultaneously (vertical stacking)
      maxPerSlot:   3,
      // Minimum vertical clearance between two jellyfish in same slot (px)
      slotClearance: 65,
      respawnGapMs: 800,   // gap after a jellyfish exits before next spawn
      sizeVariance: 0.12,
      xJitter:      5,
      rotMaxDeg:    3,
      rotAmpDeg:    0.9,
    };

    var naturalRatio = 1;
    var rafId        = null;
    var lastTs       = 0;
    var isPaused     = false;
    var destroyed    = false;
    var pausedAt     = 0;

    /** @type {Array<object>} */
    var active = [];

    // Per-slot runtime state
    var slotStates = SLOTS.map(function (def, i) {
      return {
        def:          def,
        anims:        [],          // currently active jellyfish in this slot
        nextSpawnAt:  Infinity,    // managed after exit / prefill
        initIndex:    i,           // used to stagger prefill Y positions
      };
    });

    function rand(a, b)       { return Math.random() * (b - a) + a; }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    // ── Can we spawn another jellyfish in this slot? ─────────────────────────
    function canSpawnInSlot(ss) {
      if (ss.anims.length >= CFG.maxPerSlot) return false;
      if (ss.anims.length === 0) return true;

      // Find the jellyfish with the highest Y (lowest on screen = most recent spawn)
      var lowestY = -Infinity;
      var lowestH = 0;
      var i;
      for (i = 0; i < ss.anims.length; i++) {
        var a = ss.anims[i];
        if (a.y > lowestY) { lowestY = a.y; lowestH = a.h || 0; }
      }

      // New jellyfish will start at window.innerHeight + overscan.
      // Require at least slotClearance px of gap between the two.
      var spawnY = window.innerHeight + CFG.overscanPx;
      return (spawnY - (lowestY + lowestH)) >= CFG.slotClearance;
    }

    // ── Spawn one jellyfish into a slot ──────────────────────────────────────
    function spawnSlot(ss, overrideY) {
      if (destroyed) return;
      if (!canSpawnInSlot(ss) && typeof overrideY !== 'number') return;

      var def = ss.def;
      var vw  = window.innerWidth;
      var vh  = window.innerHeight;

      var w = Math.round(def.wPct * vw * rand(1 - CFG.sizeVariance, 1 + CFG.sizeVariance));
      var h = Math.round(w / naturalRatio);
      var x = clamp(Math.round(def.xPct * vw + rand(-CFG.xJitter, CFG.xJitter)), 0, vw - w);

      var item = document.createElement('div');
      item.className   = 'bg-item';
      item.style.width = w + 'px';
      item.style.left  = x + 'px';
      item.style.zIndex = def.isLarge ? '8' : '2';

      var img      = document.createElement('img');
      img.alt      = '';
      img.decoding = 'async';
      img.loading  = 'eager';
      img.src      = getImg();
      if (!def.isLarge) img.style.filter = 'blur(0.4px)';

      item.appendChild(img);
      container.appendChild(item);

      var startY = (typeof overrideY === 'number')
        ? overrideY
        : vh + CFG.overscanPx + rand(0, 40);

      var endY  = -(h + CFG.overscanPx);
      var speed = CFG.basePx * (def.isLarge ? CFG.largeFactor : CFG.smallFactor) * rand(0.90, 1.10);

      var anim = {
        el:       item,
        slot:     ss,
        y:        startY,
        endY:     endY,
        speed:    speed,
        h:        h,
        rotBase:  rand(-CFG.rotMaxDeg, CFG.rotMaxDeg),
        rotAmp:   rand(0.2, CFG.rotAmpDeg),
        rotSpeed: rand(0.30, 0.70),
        rotPhase: rand(0, Math.PI * 2),
      };

      ss.anims.push(anim);
      active.push(anim);
      applyTransform(anim, performance.now());
    }

    function applyTransform(anim, ts) {
      var wobble = Math.sin(ts / 1000 * anim.rotSpeed + anim.rotPhase) * anim.rotAmp;
      anim.el.style.transform =
        'translate3d(0,' + anim.y.toFixed(1) + 'px,0) rotate(' +
        (anim.rotBase + wobble).toFixed(2) + 'deg)';
    }

    // ── Prefill: distribute 2 jellyfish per slot across the full screen ───────
    function prefill() {
      var vh      = window.innerHeight;
      var overscan = CFG.overscanPx;

      slotStates.forEach(function (ss) {
        ss.nextSpawnAt = Infinity;

        // 3 jellyfish per slot: bottom, middle, upper (spread across full screen height)
        spawnSlot(ss, vh * 0.75 + rand(0, vh * 0.20));  // lower area
        spawnSlot(ss, vh * 0.25 + rand(0, vh * 0.25));  // middle area
        spawnSlot(ss, -overscan * 0.5 + rand(0, vh * 0.20)); // upper / above viewport
      });
    }

    // ── Animation loop ────────────────────────────────────────────────────────
    function start() {
      prefill();

      function loop(ts) {
        if (destroyed) return;

        if (isPaused) { lastTs = 0; rafId = requestAnimationFrame(loop); return; }
        if (!lastTs) lastTs = ts;
        var dt = Math.min(0.05, (ts - lastTs) / 1000);
        lastTs = ts;

        var now = performance.now();
        var i, a, idx;

        // Move jellyfish; handle exits
        for (i = active.length - 1; i >= 0; i--) {
          a = active[i];
          if (!a) continue;
          a.y -= a.speed * dt;

          if (a.y <= a.endY) {
            a.el.remove();

            // Remove from slot's anims list
            idx = a.slot.anims.indexOf(a);
            if (idx !== -1) a.slot.anims.splice(idx, 1);
            active.splice(i, 1);

            // Schedule next spawn for this slot
            if (a.slot.nextSpawnAt === Infinity || a.slot.nextSpawnAt < now) {
              a.slot.nextSpawnAt = now + CFG.respawnGapMs;
            }
          } else {
            applyTransform(a, ts);
          }
        }

        // Check each slot — spawn if there's room and timer allows
        slotStates.forEach(function (ss) {
          if (canSpawnInSlot(ss) && now >= ss.nextSpawnAt) {
            spawnSlot(ss);
            // Brief cooldown before checking this slot again
            ss.nextSpawnAt = now + 500;
          }
        });

        rafId = requestAnimationFrame(loop);
      }

      rafId = requestAnimationFrame(loop);

      // Visibility pause with timer offsetting
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          isPaused = true;
          pausedAt = performance.now();
        } else {
          isPaused = false;
          lastTs   = 0;

          var hiddenFor = performance.now() - pausedAt;
          var now       = performance.now();
          var stagger   = 0;

          slotStates.forEach(function (ss) {
            if (ss.nextSpawnAt === Infinity) return;
            ss.nextSpawnAt += hiddenFor;
            if (ss.nextSpawnAt <= now) {
              ss.nextSpawnAt = now + stagger;
              stagger += 200 + Math.random() * 200;
            }
          });
        }
      });
    }

    // ── Init ──────────────────────────────────────────────────────────────────
    (function init() {
      var preload    = new Image();
      preload.onload = function () {
        naturalRatio = preload.naturalWidth / preload.naturalHeight || 1;
        start();
      };
      preload.onerror = function () { naturalRatio = 1; start(); };
      preload.src = imagePool[0] || imageUrl;
    })();

    // ── Shopify section unload ─────────────────────────────────────────────────
    document.addEventListener('shopify:section:unload', function (ev) {
      var sec = ev && ev.target;
      if (!sec) return;
      if (!(/** @type {HTMLElement} */(sec)).contains(container)) return;
      destroyed = true;
      if (rafId !== null) cancelAnimationFrame(rafId);
      container.innerHTML = '';
      container.dataset.floatingBgInit = '0';
    });
  });
})();